import React, { useContext, useEffect } from "react";
import './theClientOutlet.style.scss';
import { AccountContext } from "../../Contexts/main.context";
import { ClientContext } from "../../Contexts/client.context";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import ClientClientLocations from "./clientLocation.component";
import ClientCitationBoard from "./clientCitationBoard.component";

const TheClientOutput = () => {
     const { activeOutlet, updateActiveOutlet, activeClient,  myAccount, updateMyAccount } = useContext(AccountContext);
     const {clientLocations} = useContext(ClientContext);
     const navigate = useNavigate();

     useEffect(() => {
          const token = localStorage.getItem('LGOUser');
          if (!myAccount || Object.keys(myAccount).length === 0) {
               if (token && typeof token === 'string') {
                    try {
                         const decoded = jwtDecode(token);
                         const currentTime = Math.floor(Date.now() / 1000);
                         if (decoded.exp && decoded.exp > currentTime) {
                              updateMyAccount(decoded);
                         } else {
                              localStorage.removeItem('LGOUser');
                              navigate('/login');
                         }
                    } catch (err) {
                         localStorage.removeItem('LGOUser');
                         navigate('/login');
                    }
               } else {
                    navigate('/login');
               }
          }
     }, []);
     

     const renderOutlet = () => {
          // 🔒 Guard clause: Wait for activeClient to be defined and not null
          if (activeOutlet === 'Citations' && !activeClient) return <ClientClientLocations locations={clientLocations} />;
          if (typeof activeOutlet === "string") {
               switch (activeOutlet) {
                    case 'Locations':
                         return <ClientClientLocations locations = {clientLocations} />
                    case 'Citations':
                         return <ClientCitationBoard />
                    default :
                         return <ClientClientLocations locations = {clientLocations} />
               }
          }

          return null;
     };

     return (
          <div id="theClientOutput">
               {renderOutlet()}
          </div>
     );
};

export default TheClientOutput;
